import { useEffect, useState } from 'react';

export const useCopyToClipboard = (delayTime?: number) => {
  const [isDelay, setIsDelay] = useState(false);

  useEffect(() => {
    if (isDelay) {
      const timeoutId = setTimeout(() => setIsDelay(prevState => !prevState), delayTime || 2000);

      return () => clearTimeout(timeoutId);
    }
  }, [isDelay]);

  const copyToClipboardHandler = (value: string) => {
    navigator.clipboard.writeText(value);
    setIsDelay(prevState => !prevState);
  };

  return { isDelay, copyToClipboardHandler };
};
